// @ts-nocheck

import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components
import SoftBox from "../../../../components/common/softBox";
import SoftTypography from "../../../../components/common/softTypography";

// Soft UI Dashboard React examples
import DefaultNavbar from "../../../../components/navbars/defaultNavbar";
import PageLayout from "../../../../components/layoutContainers/pageLayout";

// Authentication layout components
import Footer from "../../../../components/footer";

{/* @ts-ignore  */ }

function CoverLayout({ color, header, title, description, image, top, children }) {
  return (
    <PageLayout >
      {/* <DefaultNavbar
        action={{
          type: "external",
          route: "https://creative-tim.com/product/soft-ui-dashboard-react",
          label: "free download",
          color: "dark",
        }}
      /> */}
      <Grid
        container
        justifyContent="center"
        display="flex"
        alignItems="center"
        sx={{
          minHeight: "100vh",
          margin:0,
        }}
      >
        <Grid item xs={11} sm={8} md={5} xl={3}>
          {/* @ts-ignore  */}

          <SoftBox px={3} py={3} >
            {/* @ts-ignore  */}

            <SoftBox pb={3} borderBottom="1px solid #eee" borderRadius="none">
              {!header ? (
                <>
                  {/* @ts-ignore  */}

                  <SoftBox  mb={1} textAlign="center" >
                    {/* @ts-ignore  */}

                    <SoftTypography textAlign="center" variant="h3" fontWeight="bold" color={color} >
                      {title}
                    </SoftTypography>
                  </SoftBox>
                  {/* @ts-ignore  */}

                  <SoftTypography variant="body2" textAlign="center" fontWeight="regular" color="text">
                    {description}
                  </SoftTypography>
                </>
              ) : (
                header
              )}
            </SoftBox>
            {/* @ts-ignore  */}

            <SoftBox pt={2}>{children}</SoftBox>
          </SoftBox>
        </Grid>

      </Grid>
      {/* <Footer /> */}
    </PageLayout>
  );
}

// Setting default values for the props of CoverLayout
CoverLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
  top: 20,
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
